export const APPROVAL_TYPES = [
    { value: 'PAYMENT', label: 'Zahlung' },
    { value: 'EXPENSE', label: 'Beleg / Ausgabe' },
    { value: 'BOOKING', label: 'Buchung' },
];

export const STATUS_OPTIONS = [
    { value: 'PENDING', label: 'Offen' },
    { value: 'APPROVED', label: 'Freigegeben' },
    { value: 'REJECTED', label: 'Abgelehnt' },
];

export const AUDIT_DEFAULT_FILTER = {
    entityType: 'ApprovalRequest',
    entityId: '',
    action: '',
    actorId: '',
    from: '',
    to: '',
};
